export async function postMessageToBuyerApp(
  type: // auth
  | "buyer-auth" // go to auth screen (native)
    // product
    | "store-info" // go to store info screen (native)
    | "store-whatsapp" // launch WA from app [data: phoneNumber]
    | "product-detail" // go to product detail screen (native)
    | "cart-floating-button" // go to cart menu (native)
    // cart
    | "back-to-product-from-cart" // go to product menu (web) from cart menu (native)
    | "cart-product-change" // floating cart btn & cart menu (native) update
    // checkout
    | "kyc-verification-payment-method" // pop up kyc store & identity for payment method tempo
    | "kyc-verification-voucher" // pop up kyc store for voucher
    | "order-success" // go to order detail page (web) after succeed checkout order [data: trxNumber]
    // order
    | "order-detail" // go to order detail page (web) [data: trxNumber]
    | "back-to-order" // back to order list screen (native)
    | "back-to-product-from-order" // back to product menu (native) from order detail page (web)
    | "repeat-order" // go to cart menu (native) after add to cart order items from web side
    // misc
    | "custom-whatsapp" // launch WA from app [data: phoneNumber-message]
    | "product-list-atc" // show add to cart from product list item
    | "product-list-filter", // trigger native sort bottomsheet
  data?: string
) {
  if (!window) return;

  let message = type;
  if (data) message += "-" + data;
  await window?.webEventHandler?.postMessage(message);

  if (process && process.env.NODE_ENV === "development") {
    console.log(message);
  }
}
